import { render } from "./ProductMoreInfo.vue?vue&type=template&id=2e666552&scoped=true&ts=true"
import script from "./ProductMoreInfo.vue?vue&type=script&lang=ts"
export * from "./ProductMoreInfo.vue?vue&type=script&lang=ts"

import "./ProductMoreInfo.vue?vue&type=style&index=0&id=2e666552&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e666552"]])

export default __exports__